import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { checkTextTranslation, checkTranslation, imageAddress, translate } from "../../utils/useful";
import * as actions from "../../stores/actionsList"
import AudioPlayer from "../../windows/AudioPlayer";
import AudioPlayerTower from "../../windows/AudioPlayerTower";
import CallTower from "../../windows/CallTower";
import { languagesInfo, siteTheme } from '../../variables/config'
import i18n from 'i18next';

class MainTower extends Component {
    state = {
        actions: [
            { label: '{{lang}}Search', img: '/assets/icons/useful/search.png', function: 'openWindow', value: 'Search', format: 'newWindow' },
            { label: '{{lang}}Hubs', img: '/assets/icons/useful/group (3).png', function: 'openWindow', value: 'Hubs', format: '' },

            { label: '{{lang}}Notifications center', img: '/assets/icons/useful/notification-bell.png', function: 'openWindow', value: 'Update', notifCategory: '*', format: '' },
            { label: '{{lang}}Requests', img: '/assets/icons/useful/rocket.png', function: 'openWindow', value: 'Request', num: 0, format: '' },

            // { label: '{{lang}}Calendar', img: '/assets/icons/tower/search-tower.svg', function: 'openWindow', value: 'Calendar', format: 'newWindow' },
            { label: '{{lang}}Create Hub', img: '/assets/icons/useful/user.png', function: 'openWindow', value: 'createhub', format: 'newWindow' },
            { label: '{{lang}}Create Applet', img: '/assets/icons/useful/categorise.png', function: 'openWindow', value: 'createapplet', format: 'newWindow' },
            { label: '{{lang}}Portals', img: '/assets/icons/useful/subtitle.png', function: 'openWindow', value: 'Portals', format: '' },
            { label: '{{lang}}Dashboard', img: '/assets/icons/useful/home (1).png', function: 'openWindow', value: 'Dashboard', format: '' },

            { label: '{{lang}}Yonnect World', img: '/assets/icons/useful/worldwide.png', function: 'openWindow', value: 'yonnectworld', format: 'newWindow' },
            { label: '{{lang}}Account Settings', img: '/assets/icons/useful/setting-1.png', function: 'openWindow', value: 'settings', format: 'newWindow' },
        ],
        tabs: 'applet',
        apples: [
            { icon: '/images/p1.png', name: 'Messenger', notif: '4', },
            { icon: '/images/p2.png', name: 'Messenger', notif: '4', },
            { icon: '/images/p3.png', name: 'Messenger', notif: '4', },
            { icon: '/images/p4.png', name: 'Messenger', notif: '4', },
            { icon: '/images/p5.png', name: 'Messenger', notif: '4', },
        ]
    }
    componentDidMount() {
        // console.log('hetre')
    }

    setHubs = () => {
        this.setState({ tabs: "hubs" })
    }

    setApplet = () => {
        this.setState({ tabs: "applet" })
    }
    openApplet = (username, urlcode) => {
        let path = [username, urlcode]

        // this.props.changeWindow('applet', { path: ['a', applet.urlcode] })

        this.props.addNewWindow('applet', { path: path })
        // this.props.changeWindow('applet', { path: this.props.data?.path })
    }
    toggleLanguagesBox() {
        if (!this.state.showLanguagesBox) {
            document.addEventListener('mousedown', this.closeBox);
            this.setState({ showLanguagesBox: true })
        } else {
            this.closeBox()
        }
    }
    changeLanguage = (key, value) => {
        i18n.changeLanguage(value)
        this.closeBox()
    }
    render() {

        return (

            <div className=" h-100 flex-1">
                <div className="flex-column" style={{}}>
                    <div className="tower-body" style={{}}>
                        <div className="pb-2" style={{ backgroundColor: '#fff' }}>
                            <div className="flexc pt-2 mx-3" >
                                <button className={"mrd-2 br-20 " + (this.state.tabs == 'applet' ? '' : '')} onClick={() => this.setApplet()} style={{ background: this.state.tabs == 'applet' ? 'linear-gradient(to right, rgb(124, 122, 255), rgb(88, 86, 214))' : 'linear-gradient(to right, #e0e0e0, #e0e0e0)', }}>
                                    <p className={"px-3 py-2 flexcc weight-500 font-size-13 text-smaller " + (this.state.tabs == 'applet' ? 'white' : 'main-c7')}>{translate("Applets")}</p>
                                    {/* <div className="br-20" style={{ backgroundColor: this.state.tabs == 'applet' ? '#007aff' : ' #f6f6f6', height: '2px', transform: ' translateY(2.2px)' }}></div> */}
                                </button>
                                <button className={"mld-2 br-20 " + (this.state.tabs == 'hubs' ? '' : '')} onClick={() => this.setHubs()} style={{ background: this.state.tabs == 'hubs' ? 'linear-gradient(to right, rgb(124, 122, 255), rgb(88, 86, 214)' : 'linear-gradient(to right, #e0e0e0, #e0e0e0)', }}>
                                    <p className={"px-3 py-2 flexcc weight-500 font-size-13 text-smaller " + (this.state.tabs == 'hubs' ? 'white' : 'main-c7')}>{translate("Hubs")}</p>
                                    {/* <div className="br-20" style={{ backgroundColor: this.state.tabs == 'hubs' ? '#007aff' : ' #f6f6f6', height: '2px', transform: ' translateY(2.2px)' }}></div> */}
                                </button>
                            </div>
                            {this.state.tabs == 'hubs' && (
                                <div className="flexc sc-gray-mx p-1 mx-2  " style={{ overflowX: 'auto', backgroundColor: '#fff' }}>
                                    {this.props.relations.relations.map((item, index) => {
                                        return (
                                            <div key={index} className="pb-3 pt-2 prd-1 flexcc flex-column position-relative" style={{ transition: 'all 0.5s', cursor: 'pointer', }} onClick={() => { this.props.addNewWindow("hub", { path: [item.targetHub?.username], type: 'hub' }, "center"); this.props.toggle() }}>
                                                <img src={imageAddress(item?.targetHub?.image, "profile", 'thumb')} style={{ width: '40px', height: '40px', borderRadius: 40, objectFit: 'cover', border: '1px solid #eee' }} />
                                                <div className="flexcc mt-2" style={{ width: '70px', textAlign: 'center' }}>
                                                    <p className="mb-0 font-size-12 text-semibold" style={{ color: '#202020', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>{checkTextTranslation(item?.targetHub?.name)}</p>
                                                </div>

                                                {this.props.inbox.appletHubs[item?.targetHub?._id]?.count > 0 && (
                                                    <div className="br-30 flexcc" style={{ backgroundColor: '#ee5050', minWidth: '20px', height: '20px', position: 'absolute', top: 0, right: 12 }}>
                                                        <p className="white font-size-12 text-semibold">{this.props.inbox.appletHubs[item?.targetHub?._id]?.count}</p>
                                                    </div>
                                                )}
                                            </div>
                                        )
                                    })}
                                </div>
                            )}
                            {this.state.tabs == 'applet' && (
                                <div className="flexc sc-gray-mx p-1 mx-2  " style={{ overflowX: 'auto', backgroundColor: '#fff' }}>
                                    {Array.isArray(this.props.connection?.connections)&&this.props.connection?.connections?.map((item, index) => {
                                        return (
                                            <div key={index} className="pb-1 pt-2 prd-3 d-flex flex-column " style={{ transition: 'all 0.5s', cursor: 'pointer' }} onClick={() => { this.openApplet(item.appletHub.username, item.applet.urlcode); this.props.toggle() }} >
                                                <div className="flexcc flex-column" style={{ position: 'relative' }}>

                                                    {item.icon ? (
                                                        <img src={imageAddress(item.icon, 'applet')} style={{ width: '40px', height: '40px', borderRadius: 50, objectFit: 'cover', }} alt="" />
                                                    ) : (
                                                        <img src={('/assets/icons/applets/' + ((item?.features && item?.features[0]) ? String(item?.features[0]).toLowerCase() : String(item.applet?.type).toLowerCase()) + ".png")} style={{ width: '40px', height: '40px', borderRadius: 10, objectFit: 'cover' }} alt="" />
                                                    )}
                                                    <p className="mb-0 font-size-12 text-semibold mt-2 text-center" style={{ color: '#202020', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '70px' }}>{checkTranslation(item.applet?.name)}</p>
                                                    <p className="mb-0 font-size-10  text-center" style={{ color: '#999', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '70px' }}>{checkTranslation(item.appletHub?.fullname)}</p>

                                                    {this.props.inbox.object[item.applet?._id]?.count > 0 && (
                                                        <div className="br-30 flexcc" style={{ backgroundColor: '#ee5050', minWidth: '20px', height: '20px', position: 'absolute', top: -6, right: 12 }}>
                                                            <p className="white font-size-12 text-semibold">{this.props.inbox.object[item.applet._id]?.count}</p>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            )}
                        </div>
                        <div className="pb-3" style={{ padding: '0px 15px' }}>
                            {this.state.actions.map((prop, index) => {
                                let count = 0
                                if (prop.value == 'Request') {
                                    count = this.props.inbox.categorizer?.request?.count ?? 0
                                }
                                if (prop.value == 'Update') {
                                    // count = this.props.inbox.categorizer?.request?.count ?? 0
                                }
                                return (
                                    <div key={index}>
                                        {prop.format == 'newWindow' ? (
                                            <div className="" style={{ cursor: 'pointer' }} onClick={() => { this.props.addNewWindow(prop.value, {}, "center"); this.props.toggle() }}>
                                                <div className="my-2 py-1 flexcb pb-3" style={{ borderBottom: '1px solid #f2f6f8', borderRadius: 0 }}>
                                                    <div className="flexc">
                                                        <img src={prop.img} width={20} className="mrd-2 grayscale-filter" alt="" />
                                                        <p className="text-semibold mld-2">{checkTranslation(prop.label)}</p>
                                                    </div>
                                                    <div className="flexc">
                                                        {prop.notifCategory && this.props.inbox.categorizer && this.props.inbox.categorizer[prop.notifCategory]?.count > 0 &&
                                                            <div className="br-20 flexcc px-1" style={{ backgroundColor: '#ee5050', minWidth: '22px', height: '22px' }}>
                                                                <p className="font-size-12" style={{ color: '#fff' }}>{this.props.inbox.categorizer[prop.notifCategory]?.count}</p>
                                                            </div>
                                                        }
                                                        <img src="/assets/icons/tower/arrow-right.svg" className='rtl-button' height={16} />
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="w-100" style={{ cursor: 'pointer' }} onClick={() => { this.props.changeStage(prop.value) }}>
                                                <div className="flexcb w-100 mb-2 py-1 flexc pb-3" style={{ borderBottom: '1px solid #f2f6f8', borderRadius: 0 }}>
                                                    <div className="flexcb w-100">
                                                        <div className="flexc">
                                                            <img src={prop.img} width={20} className="mrd-2 grayscale-filter" alt="" />
                                                            <p className="text-semibold mld-2">{checkTranslation(prop.label)}</p>
                                                        </div>
                                                        <div className="flexc">
                                                            {prop.notifCategory && this.props.inbox.categorizer && this.props.inbox.categorizer[prop.notifCategory]?.count > 0 &&
                                                                <div className="br-20 flexcc px-1" style={{ backgroundColor: '#ee5050', minWidth: '22px', height: '22px' }}>
                                                                    <p className="font-size-12" style={{ color: '#fff' }}>{this.props.inbox.categorizer[prop.notifCategory]?.count}</p>
                                                                </div>
                                                            }
                                                            <img src="/assets/icons/tower/arrow-right.svg" className='rtl-button' height={16} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )
                            })}

                            <div className="" style={{ cursor: 'pointer' }} onClick={() => this.props.LogoutModal()}>
                                <div className="mb-2 py-1 flexcb pb-3" style={{}}>
                                    <p className="text-semibold">{translate(`Log out`)}</p>
                                    <img src="/assets/icons/tower/logout.svg" className='rtl-button' height={20} />
                                </div>
                            </div>
                            <div className="flexcc w-100 mt-3">
                            {languagesInfo[this.props.settings.language] && (
                                <div className=" " style={{ position: 'relative', }}>
                                    <button onClick={() => this.toggleLanguagesBox()} className="flexcc language-but p-0">
                                        <img className="" src={languagesInfo[this.props.settings.language].icon} height="20px" alt="" />
                                        <span className=" mld-2" style={{ color: siteTheme.themeColors.headerFont }}>{languagesInfo[this.props.settings.language].name}</span>
                                    </button>
                                    {this.state.showLanguagesBox && (
                                        <div ref={el => this.language_select_box = el} className="blur-back language-select-box fadein">
                                            {Object.values(languagesInfo).map((prop, index) => {
                                                return (
                                                    <button key={index} className={" flexc language-select-option " + (index !== 0 ? "mt-3" : '')} onClick={() => this.changeLanguage('language', prop.shortName)}>
                                                        <img className="mrd-2" src={prop.icon} alt={"language-" + prop.name} />
                                                        <div>{prop.name}</div>
                                                    </button>
                                                )
                                            })}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => ({ settings: state.settings, user: state.user, resource: state.resource, notif: state.notif, relations: state.relations, connection: state.connection, inbox: state.inbox });
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch)
});


export default connect(mapStateToProps, mapDispatchToProps)(MainTower);